import Joi from '../../../Lib/Utils/Joi';

export default {
  pageTitle: 'Vendor Information',
  cards: [
    {
      title: 'Supplier / Vendor Contact Information',
      fields: [
        {
          label: 'Entity Legal Name',
          name: 'entityLegalName',
          type: 'text',
          disabled: true,
          required: true,
        },
        {
          label: 'Registration Email',
          name: 'registrationEmail',
          type: 'text',
          required: true,
          disabled: true,
        },
        {
          label: 'Doing Business As (DBA), if any',
          name: 'doingBusinessAs',
          type: 'text',
          required: false,
          default: null,
          specialValidation: Joi.string().allow(null),
        },
        {
          label: 'Website URL',
          name: 'websiteUrl',
          type: 'text',
        },
      ],
    },
    {
      title: 'Primary Point Of Contact',
      fields: [
        {
          label: 'First Name',
          name: 'firstName',
          type: 'text',
          required: true,
        },
        {
          label: 'Last Name',
          name: 'lastName',
          type: 'text',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
        },
        {
          label: 'Email Address',
          name: 'emailAddress',
          type: 'text',
          required: true,
          specialValidation: Joi.string().email({ tlds: { allow: false } }),
        },
        {
          label: 'Phone Number',
          name: 'phoneNumber',
          type: 'text',
          required: true,
          specialValidation: Joi.string()
            .phoneNumber()
            .vpPhoneNumber()
            .required(),
        },
        {
          label: 'Search your address',
          name: 'searchAddress',
          type: 'address',
          required: true,
          names: {
            country: 'country',
            addressLine1: 'addressLine1',
            addressLine2: 'addressLine2',
            postalCode: 'postalZipCode',
            city: 'city',
            state: 'stateProvince',
          },
        },
      ],
    },
  ],
};
